import { cloneDeep } from 'lodash';

import { SerializableObjectSchema } from '../../../../../objects/generic/serialization/serializable-object-schema';
import { PossibleRole } from '../../../../../objects/user/roles/types';
import { CommunicationsRequestName } from '../../../communications-request-name';
import { CommunicationsRequest } from '../../generic/communications-request/communications-request';
import { CommunicationsRequestSchema } from '../../generic/communications-request/communications-request-schema';

import { CommunicationsRequestConferenceEndConstructor } from './communications-request-conference-end-constructor';
import { CommunicationsRequestConferenceEndSchema } from './communications-request-conference-end-schema';

export class CommunicationsRequestConferenceEnd extends CommunicationsRequest {
  /////////////////////////////////////////////////////////////////////////////
  // Variables
  /////////////////////////////////////////////////////////////////////////////

  protected conferenceFriendlyName!: string;

  /////////////////////////////////////////////////////////////////////////////
  // Constructor
  /////////////////////////////////////////////////////////////////////////////

  constructor(parameters: CommunicationsRequestConferenceEndConstructor) {
    super({ ...parameters, [CommunicationsRequestSchema.type]: CommunicationsRequestName.conferenceEnd });
  }

  /////////////////////////////////////////////////////////////////////////////
  // Deserialize
  /////////////////////////////////////////////////////////////////////////////

  protected static _deserialize(
    validationResult: import('joi').ValidationResult,
  ): CommunicationsRequestConferenceEnd {
    return new CommunicationsRequestConferenceEnd(super._deserialize(validationResult));
  }

  /////////////////////////////////////////////////////////////////////////////
  // Serialize
  /////////////////////////////////////////////////////////////////////////////

  public serialize() {
    return super.serialize(CommunicationsRequestConferenceEnd.getSchema());
  }

  /////////////////////////////////////////////////////////////////////////////
  // Schema
  /////////////////////////////////////////////////////////////////////////////

  public static getSchema(): SerializableObjectSchema {
    return new CommunicationsRequestConferenceEndSchema();
  }

  /////////////////////////////////////////////////////////////////////////////
  // Roles
  /////////////////////////////////////////////////////////////////////////////

  // eslint-disable-next-line class-methods-use-this
  public getRequiredRoles(): PossibleRole[] {
    return [];
  }

  // eslint-disable-next-line class-methods-use-this
  public getRequiredAdminRoles() {
    return [];
  }

  /////////////////////////////////////////////////////////////////////////////
  // Getters
  /////////////////////////////////////////////////////////////////////////////

  public getConferenceFriendlyName() {
    return cloneDeep(this.conferenceFriendlyName);
  }
}
